import {firebase} from "../firebase/clientApp";

export const getAuthToken = async () => {
    try {
        return "Bearer " + await firebase.auth().currentUser?.getIdToken();
    } catch(err) {
        console.log("getAuthToken", err);
    };
};
